import { QueryClient } from "@tanstack/react-query";
import axios from "axios";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // don't retry client errors except 429; retry server errors up to 2x
        if (axios.isAxiosError(error)) {
          const s = error.response?.status ?? 0;
          if (s && s < 500 && s !== 429) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
